<p-blockUI [target]="loadingContainer" [blocked]="(isLoading$ | async)!">
  <i class="pi pi-lock" style="font-size: 2rem"></i>
</p-blockUI>
<carbon-loading-blockable [ngClass]="blockableClasses" #loadingContainer>
  <ng-content></ng-content>
</carbon-loading-blockable>
